import { Grid, withStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { history } from '@app/app.routes';
import AccountAppComponent from '@app/components/account/app/account-app';
import { withAxiosCancellation } from '@app/components/core/axios-cancel.component';
import * as models from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';

const styles: StyleRules = {
	keyInput: {
		fontSize: 16,
		padding: '10px 14px',
	},
	textLabel: {
		fontSize: 18,
	},
};
const accountService: AccountService = Injector.get(AccountService);

class AdminAccountAppDetalsComponent extends React.Component<models.IAdminCustomerProps, any> {
	constructor(props: models.IAdminCustomerProps) {
		super(props);
		this.state = {
			userRole: accountService.getUserData().user.role,
		};
	}

	public render() {
		const gridValue = !accountService.IsAdmin(this.state.userRole) ? 12 : 8;
		return (
			<React.Fragment>
				<Grid container={true} direction='column' spacing={2}>
					<Grid item={true} xl={gridValue} lg={gridValue} xs={12} sm={12}>
						<AccountAppComponent history={history} />
					</Grid>
				</Grid>
			</React.Fragment>
		);
	}
}
export default withRouter(withAxiosCancellation(withStyles(styles)(injectIntl(AdminAccountAppDetalsComponent))));



// WEBPACK FOOTER //
// ./src/components/admin/customer/admin-account-app-details.component.tsx